import { memo } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2 } from "lucide-react";
import { HospitalCard } from "./HospitalCard";
import type { Hospital } from "@/types/schema";
import { Button } from "@/components/ui/button";
import { SmoothLink as Link } from "@/components/navigation";

interface HospitalsListProps {
  hospitals: Hospital[];
}

export const HospitalsList = memo(function HospitalsList({ hospitals }: HospitalsListProps) {
  if (hospitals.length === 0) {
    return (
      <Card>
        <CardContent className="p-6 text-center space-y-4">
          <div className="p-3 bg-accent/10 rounded-full w-fit mx-auto">
            <Building2 className="w-8 h-8 text-accent" />
          </div>
          <div>
            <h2 className="font-semibold text-lg text-secondary">Our Partner Network</h2>
            <p className="text-muted-foreground max-w-md mx-auto">
              We work with top JCI-accredited hospitals for this procedure. Contact us for the full list.
            </p>
          </div>
          <Link to="/contact/">
            <Button variant="outline" className="rounded-full">View Hospital Network</Button>
          </Link>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle as="h2" className="flex items-center gap-2">
          <Building2 className="w-5 h-5 text-primary" />
          Partner Hospitals ({hospitals.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {hospitals.map((hospital) => (
            <HospitalCard key={hospital.id} hospital={hospital} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
});
